// @flow
import {
  WebComponent,
} from 'fg-frontend';

import gsap from 'gsap';

const fragments = {
  menuToggler: '[data-fragment="menuToggler"]',
  searchToggler: '[data-fragment="searchToggler"]',
  navLink: '[data-fragment="navLink"]',
  megaMenu: '[data-fragment="megaMenu"]',
  menuSearchBar: '[data-fragment="menuSearchBar"]',
  headerNav: '[data-fragment="headerNav"]'
};

export default class MenuCollapse extends WebComponent{

  constructor(props){
    super(props);
    this.state = {
      menuOpened: false,
      menuSearch: false,
      megaMenuOpened: false
    }
  }

  didMount() {
    this.on('click', fragments.searchToggler, this.handleSearchmenuToggle);
    this.on('click', fragments.menuToggler, this.handleMenuToggle);
    this.on('mouseover', fragments.navLink, this.handleMegamenuToggle);
    this.on('mouseleave', this.handleMouseleaveMegamenu);
  }

  handleSearchmenuToggle = (e) => {
    // console.count('handleSearchmenuToggle');
    window.addEventListener("scroll",()=>{
      if(this.state.menuSearch){
        this.setState({menuSearch: false})
      }
    })
    !this.state.menuSearch ? this.setState({menuSearch: true}) : this.setState({menuSearch: false});
  }

  handleMegamenuToggle = (e) => {
    if (window.innerWidth >= 1280) {
      if(!this.state.megaMenuOpened){
        this.setState({megaMenuOpened: true});
      }
    }
  }

  handleMouseleaveMegamenu = (e) =>{
    if (window.innerWidth >= 1280) {
      if(this.state.megaMenuOpened){
        this.setState({megaMenuOpened: false});
      }
    }
  }

  handleMenuToggle = (e) => {
    // console.count('handleMenuToggle');
    !this.state.menuOpened ? this.setState({menuOpened: true}) : this.setState({menuOpened: false});
  }

  update() {
    let searchBar = document.querySelector(fragments.menuSearchBar);
    let headerNav = document.querySelector(fragments.headerNav);
    let navLink = document.querySelector(fragments.navLink);

    // Mobile MENU
    if(this.state.menuOpened){
      headerNav.classList.add("header__nav--open");
      gsap.fromTo(".nav__content",
        {opacity: 0, y:-20},
        {opacity: 1, y:0, duration: 0.25, ease: "power3.out"});
    } else {
      headerNav.classList.remove("header__nav--open");
    }

    let mql = window.matchMedia("(min-width: 1280px)");

    // MEGAMENU on Widescreens only
    if(mql.matches){
      if(this.state.megaMenuOpened ){
        navLink.classList.add('nav__link--megaMenu');
        gsap.fromTo(fragments.megaMenu,
          {display:"none", pointerEvents:"none", opacity: 0, y:50},
          { display:"block", pointerEvents:"auto", opacity: 1, y:0, duration: 0.25, ease: "power3.out"});
      } else {
        if(!this.state.megaMenuOpened){
          navLink.classList.remove('nav__link--megaMenu');
          gsap.to(fragments.megaMenu,
            {display:"none", opacity: 0, pointerEvents:"none", y:-20, duration: 0.25, ease: "power3.out"});
        }
      }
    }

    // SEARCHBAR
    if(this.state.menuSearch){
      searchBar.classList.add("header__search--open");
      gsap.fromTo("#headerSearchForm", {opacity: 0, y:-40},
        {opacity: 1, y:0, duration: 0.35, ease: "power3.out"});
    } else {
      if(searchBar.classList.contains("header__search--open")){
        gsap.to("#headerSearchForm",
          {opacity: 0, y:-40, duration: 0.15, ease: "power3.inOut"});
        searchBar.classList.remove("header__search--open");
      }
    }

  }



}






// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/MenuCollapse.js